import {
  GameStoreConsole,
  GameStoreMobile,
  GameStorePc,
} from '@/pages/opinion/widgets/GameStorePlate';
import React from 'react';

import { connect, useHistory } from 'umi';

function GameStore({ gameInfo, filter }: any) {
  const history = useHistory();

  const handleTitleOnClick = () => {
    history.push('/opinion/Feeds/Feeds?tab=gameStore');
  };

  const { entity_type = '' } = gameInfo;
  const map: {
    [key: string]: JSX.Element;
  } = {
    mobile: (
      <GameStoreMobile
        filter={filter}
        gameInfo={gameInfo}
        handleTitleOnClick={handleTitleOnClick}
      />
    ),
    pc: (
      <GameStorePc
        filter={filter}
        gameInfo={gameInfo}
        handleTitleOnClick={handleTitleOnClick}
      />
    ),
    console: (
      <GameStoreConsole
        filter={filter}
        gameInfo={gameInfo}
        handleTitleOnClick={handleTitleOnClick}
      />
    ),
  };

  return map[entity_type];
}

export default connect((state: any) => {
  const { loading, home, opinionCommon } = state;

  return {
    userInfoLoading: loading.effects['home/getUserInfo'],
    userInfo: home.userInfo,
    gameInfo: opinionCommon.gameInfo,
  };
})(GameStore);
